import React from 'react';

const HeroBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute inset-0 bg-[#F7F5F2]" />
    {/* Fine warm grid — notebook feel */}
    <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(26,26,24,0.032)_1px,transparent_1px),linear-gradient(to_bottom,rgba(26,26,24,0.032)_1px,transparent_1px)] bg-[size:52px_52px]" />
    {/* Dot overlay fading downward */}
    <div className="absolute inset-0 bg-[radial-gradient(rgba(26,26,24,0.055)_1px,transparent_1px)] bg-[size:26px_26px]"
      style={{ maskImage: 'radial-gradient(ellipse 80% 55% at 50% 0%, black 30%, transparent 100%)' }} />
    {/* Red margin line — classic notebook */}
    <div className="absolute top-0 bottom-0 left-[88px] w-px bg-[rgba(220,80,80,0.18)] hidden lg:block" />
    {/* Warm sand blob */}
    <div className="absolute top-1/3 left-1/4 w-[480px] h-[320px] bg-[#EDE3D4] rounded-full blur-[120px] opacity-35" />
    {/* Maritime blue hint */}
    <div className="absolute top-1/4 right-1/4 w-[360px] h-[360px] bg-[#D0E4F0] rounded-full blur-[100px] opacity-25" />
    <div className="absolute bottom-0 w-full h-56 bg-gradient-to-t from-[#F7F5F2] to-transparent" />
  </div>
);

export default HeroBackground;